/// <amd-module name="Test/Analytics/TestResultsGridCommon/DurationFormatter" />
import { DurationConverter } from "Analytics/Shared/TrendChart/Common/DurationConverter";
import { DurationNormalizer } from "Analytics/Shared/TrendChart/Common/DurationNormalizer";
import { INormalizedDuration } from "Analytics/Shared/TrendChart/Common/Types";
import * as Resources from "Test/Analytics/TestResultsGridCommon/Resources";
import { TestReportDataParser } from "Test/common-util/Common.Utils";
import { format } from "VSS/Core/Util/String";

export class DurationFormatter {
    private static _getDurationInSecondsFormat(durationInSeconds: number) {
        return format(Resources.SecondsFormat, TestReportDataParser.getCustomizedDecimalValueInCurrentLocale(durationInSeconds, 2));
    }

    private static _getDurationInMinutesFormat(durationInSeconds: number) {
        return format(
            Resources.MinutesFormat,
            TestReportDataParser.getCustomizedDecimalValueInCurrentLocale(DurationConverter.convertSecondsToMinutes(durationInSeconds), 2)
        );
    }

    private static _getDurationInHoursFormat(durationInSeconds: number): string {
        return format(
            Resources.HoursFormat,
            TestReportDataParser.getCustomizedDecimalValueInCurrentLocale(DurationConverter.convertSecondsToHours(durationInSeconds), 2)
        );
    }

    private static _getDurationAriaLabelInSecondsFormat(durationInSeconds: number) {
        return format(Resources.AverageDurationInSeconds, TestReportDataParser.getCustomizedDecimalValueInCurrentLocale(durationInSeconds, 2));
    }

    private static _getDurationAriaLabelInMinutesFormat(durationInSeconds: number) {
        return format(
            Resources.AverageDurationInMinutes,
            TestReportDataParser.getCustomizedDecimalValueInCurrentLocale(DurationConverter.convertSecondsToMinutes(durationInSeconds), 2)
        );
    }

    private static _getDurationAriaLabelInHoursFormat(durationInSeconds: number): string {
        return format(
            Resources.AverageDurationInHours,
            TestReportDataParser.getCustomizedDecimalValueInCurrentLocale(DurationConverter.convertSecondsToHours(durationInSeconds), 2)
        );
    }

    public static getDurationInAbbreviatedFormat(durationInSeconds: number): string {
        const durationNormalizationUtility = new DurationNormalizer();
        const normalizedDuration: INormalizedDuration = durationNormalizationUtility.normalizeDuration(durationInSeconds);
        switch (normalizedDuration.durationUnitString) {
            case Resources.UnitInHours:
                return DurationFormatter._getDurationInHoursFormat(durationInSeconds);
            case Resources.UnitInMinutes:
                return DurationFormatter._getDurationInMinutesFormat(durationInSeconds);
            default:
                return DurationFormatter._getDurationInSecondsFormat(durationInSeconds);
        }
    }

    public static getDurationAriaLabel(durationInSeconds: number): string {
        const durationNormalizationUtility = new DurationNormalizer();
        const normalizedDuration: INormalizedDuration = durationNormalizationUtility.normalizeDuration(durationInSeconds);
        switch (normalizedDuration.durationUnitString) {
            case Resources.UnitInHours:
                return DurationFormatter._getDurationAriaLabelInHoursFormat(durationInSeconds);
            case Resources.UnitInMinutes:
                return DurationFormatter._getDurationAriaLabelInMinutesFormat(durationInSeconds);
            default:
                return DurationFormatter._getDurationAriaLabelInSecondsFormat(durationInSeconds);
        }
    }
}
